<template>
  <v-container fluid grid-list-lg>
    <v-card>
      <v-toolbar>
        <v-icon>credit_card</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Generación de Archivo de Débitos a Tarjetas</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row align="center" dense>
            <v-col cols="2">
              <span class="body-1">Generar Débitos para </span>
            </v-col>

            <v-col cols="2">
              <v-autocomplete
                v-model="formatoEnvioId"
                :items="formatosEnvio"
                item-text="descripcion"
                item-value="id"
                label="Formato "
                @change="loadPreLotes()"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <span
                v-if="
                  formatoEnvioId &&
                  formatosEnvio.find((f) => f.id == formatoEnvioId)
                    .restringeEntidadFinanciera
                "
                >(Este formato sólo admite casos de la misma Entidad - CBUs que
                comiencen con
                {{
                  formatosEnvio.find((f) => f.id == formatoEnvioId)
                    .entidadFinancieraCodigo
                }}
                )</span
              >
            </v-col>

            <v-col cols="2">
              <v-checkbox
                v-model="generarPreLote"
                label="Generar Pre Lotes"
              ></v-checkbox>
            </v-col>

            <v-col cols="2">
              <v-autocomplete
                v-model="filtro.preLoteId"
                :items="preLotes"
                item-text="id"
                item-value="id"
                label="Pre Lotes"
                :disabled="!generarPreLote"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center" dense>
            <v-col cols="2">
              <span class="body-1">Generar Archivo con </span>
            </v-col>
            <v-col cols="4">
              <v-radio-group
                v-model="filtro.queGenerar"
                column
                mandatory
                row
                dense
              >
                <v-radio label="Sólo Deuda Cuotas" value="cuotas"></v-radio>
                <v-radio
                  label="Deuda Total"
                  value="cuotas+punitorios"
                ></v-radio>
                <v-radio label="Punitorio Fijo" value="punitoriofijo"></v-radio>
                <v-radio
                  label="Sólo Total Cuotas"
                  value="cuotastotal"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="1" v-if="filtro.queGenerar == 'punitoriofijo'">
              <v-text-field
                dense
                v-model="filtro.tasaPunitorios"
                label="Tasa Punit. a Aplicar"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-expansion-panels multiple popout accordion>
          <v-expansion-panel>
            <v-expansion-panel-header v-slot="{}">
              <v-row>
                <v-col>Filtros de Origen del Crédito</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row align="center" dense>
                <v-col cols="3">
                  <v-autocomplete
                    v-model="filtro.empresaId"
                    :items="empresas"
                    item-text="nombre"
                    item-value="id"
                    label="Empresa:"
                    placeholder="Seleccione una"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="3">
                  <v-autocomplete
                    v-model="filtro.canalVentaId"
                    :items="canalesVenta"
                    item-text="nombre"
                    item-value="id"
                    label="Originadas en:"
                    placeholder="Seleccione un Canal de Venta"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="3">
                  <v-autocomplete
                    v-model="filtro.productoId"
                    :items="productos"
                    item-text="descripcion"
                    item-value="id"
                    label="Productos:"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="3">
                  <v-select
                    :items="planes"
                    v-model="filtro.planes"
                    item-text="nombre"
                    item-value="id"
                    label="Planes"
                    multiple
                  >
                    <!-- ABAJO esto es para agregar la opción de select all -->
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="togglePlanes">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              filtro.planes.length > 0 ? 'indigo darken-4' : ''
                            "
                            >{{ iconPlanes }}</v-icon
                          >
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Marcar todos</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <!-- ARRIBA esto es para agregar la opción de select all -->
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.nombre }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filtro.planes.length - 1 }} más)</span
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row align="center" dense>
                <v-col cols="4">
                  <v-checkbox
                    v-model="filtro.filtrarFechaLiquidacion"
                    label="Filtrar por Fecha de Liquidación"
                  ></v-checkbox>
                </v-col>

                <v-col cols="6" v-if="filtro.filtrarFechaLiquidacion">
                  <app-fecha-desdehasta
                    Label="Liquidación"
                    v-on:desde-changed="filtro.liquidacionDesde = $event"
                    v-on:hasta-changed="filtro.liquidacionHasta = $event"
                  >
                  </app-fecha-desdehasta>
                </v-col>
                <v-col cols="4">
                  <v-checkbox
                    v-model="filtro.filtrarFechaLiquidacionPreBCRA"
                    label="Filtrar Liquidación Pre Normativa BCRA"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header v-slot="{}">
              <v-row>
                <v-col
                  >Filtros Vencimiento/Día Cobro/Banco/Empleador/Atraso</v-col
                >
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="6">
                  <app-fecha-desdehasta
                    Label="Vencimiento Cuota"
                    v-on:desde-changed="filtro.vtoDesde = $event"
                    v-on:hasta-changed="filtro.vtoHasta = $event"
                  >
                  </app-fecha-desdehasta>
                </v-col>

                <v-col cols="2">
                  <v-checkbox
                    v-model="filtro.filtrarDiaCobro"
                    label="Filtrar por Día Cobro"
                  ></v-checkbox>
                </v-col>

                <v-col cols="2">
                  <v-text-field
                    v-if="filtro.filtrarDiaCobro"
                    v-model="filtro.diaCobroDesde"
                    label="Desde"
                  ></v-text-field>
                </v-col>

                <v-col cols="2">
                  <v-text-field
                    v-if="filtro.filtrarDiaCobro"
                    v-model="filtro.diaCobroHasta"
                    label="Hasta"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <app-fecha-desdehasta
                    Label="Fecha Cobro "
                    v-on:desde-changed="filtro.fechaCobroDesde = $event"
                    v-on:hasta-changed="filtro.fechaCobroHasta = $event"
                  >
                  </app-fecha-desdehasta>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-checkbox
                    v-model="filtro.soloPrimerVencimiento"
                    label="Traer Sólo Primer Vencimiento Impago"
                  ></v-checkbox>
                </v-col>

                <v-col cols="3" v-if="!filtro.soloPrimerVencimiento">
                  <v-checkbox
                    v-model="filtro.filtrarPorVector"
                    label="Filtrar por Vector Atraso del Crédito"
                  ></v-checkbox>
                </v-col>

                <v-col
                  cols="2"
                  v-if="
                    filtro.filtrarPorVector && !filtro.soloPrimerVencimiento
                  "
                >
                  <v-text-field
                    v-model="filtro.vectorDesde"
                    label="V.A. Desde"
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="2"
                  v-if="
                    filtro.filtrarPorVector && !filtro.soloPrimerVencimiento
                  "
                >
                  <v-text-field
                    v-model="filtro.vectorHasta"
                    label="V.A. Hasta"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="filtro.cuitEmpleador"
                    label="Cuit Empleador"
                  ></v-text-field>
                </v-col>

                <v-col cols="3">
                  <v-checkbox
                    v-model="filtro.excluirCuitEmpleador"
                    label="Excluir Cuit Ingresado"
                  ></v-checkbox>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    :items="bancos"
                    v-model="filtro.bancos"
                    item-text="descripcion"
                    item-value="codigo"
                    label="Bancos"
                    clearable
                    multiple
                    chips
                    item-color="orange"
                    :disabled="formatoSeleccionado.restringeEntidadFinanciera"
                  ></v-autocomplete>
                </v-col>

                <v-col
                  cols="3"
                  v-if="!formatoSeleccionado.restringeEntidadFinanciera"
                >
                  <v-checkbox
                    v-model="filtro.excluirBancos"
                    label="Excluir Bancos Seleccionados"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header v-slot="{}">
              <v-row>
                <v-col>Otros Filtros</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="2">
                  <v-radio-group v-model="filtro.radiosTarjeta" column>
                    <v-radio
                      label="Tarjeta Activa"
                      value="TarjetaActiva"
                    ></v-radio>
                    <v-radio
                      label="Tarjeta Inactiva"
                      value="TarjetaInactiva"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="2">
                  <v-radio-group v-model="filtro.radiosAcuerdo" column>
                    <v-radio label="Todos" value="Todos"></v-radio>
                    <v-radio label="Sin Acuerdo" value="SinAcuerdo"></v-radio>
                    <v-radio label="Con Acuerdo" value="ConAcuerdo"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="2">
                  <v-radio-group v-model="filtro.radiosRechazo" column>
                    <v-radio label="Todos" value="Todos"></v-radio>
                    <v-radio label="Sin Rechazo" value="SinRechazo"></v-radio>
                    <v-radio label="Con Rechazo" value="ConRechazo"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="2">
                  <v-radio-group v-model="filtro.radiosEstudio" column>
                    <v-radio label="Todos" value="Todos"></v-radio>
                    <v-radio
                      label="No En Estudio"
                      value="NoEnEstudio"
                    ></v-radio>
                    <v-radio label="En Estudio" value="EnEstudio"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="2">
                  <v-layout column>
                    <div v-show="filtro.radiosEstudio === 'EnEstudio'">
                      <v-autocomplete
                        v-model="filtro.estudioId"
                        :items="estudios"
                        item-text="descripcion"
                        item-value="id"
                        label="Estudio:"
                        placeholder="Seleccione uno"
                      ></v-autocomplete>
                      <v-layout>
                        <v-text-field
                          v-model="filtro.envioEstudioDesde"
                          label="Envío Estudio Desde"
                          type="date"
                          prepend-icon="event"
                        ></v-text-field>
                      </v-layout>
                      <v-layout>
                        <v-text-field
                          v-model="filtro.envioEstudioHasta"
                          label="Envío Estudio Hasta"
                          type="date"
                          prepend-icon="event"
                        ></v-text-field>
                      </v-layout>
                    </div>
                  </v-layout>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="4">
                  <v-checkbox
                    v-model="filtro.buscarDeTablaAImpactarNormales"
                    label="Buscar De Tabla [ADebitarNormales]"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="4">
                  <v-checkbox
                    v-model="filtro.filtrarFechaUltimaGeneracion"
                    label="Filtrar por Última Generación"
                  ></v-checkbox>
                </v-col>

                <v-col cols="5">
                  <app-fecha-desdehasta
                    v-if="filtro.filtrarFechaUltimaGeneracion"
                    v-on:desde-changed="filtro.ultimaGeneracionDesde = $event"
                    v-on:hasta-changed="filtro.ultimaGeneracionHasta = $event"
                  >
                  </app-fecha-desdehasta>
                </v-col>
                <v-col cols="2">
                  <v-checkbox
                    v-if="filtro.filtrarFechaUltimaGeneracion"
                    v-model="filtro.ultimaGeneracionInversa"
                    label="Selección Inversa"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                        <template>
                          <p>
                            Al seleccionar esta opción, se filtrarán los casos
                            cuya fecha de última generación NO esté en el rango
                            indicado
                          </p>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header v-slot="{}">
              <v-row>
                <v-col>Filtro Archivo Excel</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row align="center">
                <v-col>
                  <v-file-input
                    v-model="archivoFiltroOperaciones"
                    placeholder="Seleccione el archivo Excel"
                    label="Archivo Filtro"
                    prepend-icon="mdi-paperclip"
                  >
                  </v-file-input>
                </v-col>
                <v-col>
                  <v-btn @click="traerListaOperacionesDeExcel()">
                    Cargar Filtro
                  </v-btn>
                </v-col>
                <v-col>
                  <v-radio-group v-model="filtro.radiosArchivoExcel" row>
                    <v-radio label="Ignorar" value="Ignorar"></v-radio>
                    <v-radio
                      label="Solo Casos en Filtro"
                      value="SoloCasosFiltro"
                    ></v-radio>
                    <v-radio
                      label="Excluir Casos en Filtro"
                      value="ExcluirCasosFiltro"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row v-if="archivoFiltroOperaciones != null">
                <v-col>
                  <v-chip
                    v-if="filtro.operacionesFiltro.id == ''"
                    label
                    color="warning"
                  >
                    Presione Cargar Filtro para procesar el archivo
                  </v-chip>

                  <template v-else>
                    <v-chip
                      label
                      color="info"
                      v-if="filtro.radiosArchivoExcel == 'Ignorar'"
                    >
                      Hay {{ filtro.operacionesFiltro.cantidad }} Créditos en el
                      Filtro pero no se tendrán en cuenta
                    </v-chip>
                    <v-chip
                      label
                      color="green"
                      dark
                      v-if="filtro.radiosArchivoExcel == 'SoloCasosFiltro'"
                    >
                      Se incluirán solo los
                      {{ filtro.operacionesFiltro.cantidad }} Créditos del
                      Filtro
                    </v-chip>
                    <v-chip
                      label
                      color="red"
                      dark
                      v-if="filtro.radiosArchivoExcel == 'ExcluirCasosFiltro'"
                    >
                      Se Excluirán los
                      {{ filtro.operacionesFiltro.cantidad }} Créditos del
                      Filtro
                    </v-chip>
                  </template>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header v-slot="{}">
              <v-row>
                <v-col
                  >Opciones de Reciclaje y Cálculo de Fechas de Débito</v-col
                >
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row dense>
                <v-col cols="2">
                  <v-switch label="Reciclaje" v-model="filtro.reciclaje">
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                        <template>
                          <p>
                            Al seleccionar esta opción, se podrá especificar una
                            Fecha de Débito (fija) para todos los casos
                          </p>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-switch>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-if="filtro.reciclaje"
                    v-model="filtro.fechaReciclaje"
                    label="Fecha Débito"
                    type="date"
                    prepend-icon="event"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-switch
                    label="Diferir Fecha Débito"
                    v-if="!filtro.reciclaje"
                    v-model="filtro.diferirFechaDebito"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                        <template>
                          <p>
                            Al seleccionar esta opción, se podrán indicar
                            cuántos días (hábiles) sumar a la fecha calculada
                            por el sistema
                          </p>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-switch>
                </v-col>
                <v-col cols="1">
                  <v-text-field
                    v-if="filtro.diferirFechaDebito"
                    v-model="filtro.diasDiferirFechaDebito"
                    label="diferir"
                    suffix="días"
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="2">
                  <v-switch
                    label="Dividir Cuotas"
                    v-model="filtro.dividirCuotas"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                        <template>
                          <p>
                            Al seleccionar esta opción, se podrá especificar en
                            cuántas mini-cuotas dividir cada una de las cuotas
                            originales
                          </p>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-switch>
                </v-col>
                <v-col cols="2" v-if="filtro.dividirCuotas">
                  <v-switch
                    label="Iguales"
                    v-model="filtro.dividirCuotasIguales"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                        <template>
                          <p v-if="filtro.dividirCuotasIguales">
                            Al seleccionar esta opción, se dividirán las cuotas
                            todas del mismo importe
                          </p>
                          <p v-else>
                            Al seleccionar esta opción, se dividirán las cuotas
                            en partes desiguales, según: 2 partes: 60/40 - 3
                            partes: 40/35/25 - 4 partes: 40/30/20/10
                          </p>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-switch>
                </v-col>
                <v-col cols="1">
                  <v-text-field
                    v-if="filtro.dividirCuotas"
                    v-model="filtro.dividirCuotasEn"
                    label="dividir en"
                    :suffix="
                      filtro.dividirCuotasIguales
                        ? 'partes iguales'
                        : 'partes desiguales'
                    "
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-switch
                    v-if="filtro.dividirCuotas"
                    label="Enviar Sólo 1er Parte"
                    v-model="filtro.enviarPrimerParte"
                  >
                  </v-switch>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    v-model="filtro.dividirCuotasMaximo"
                    label="Cuota Máxima"
                  >
                  </v-text-field>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-checkbox
                    v-model="filtro.diaCobroPorFechaReal"
                    label="Día de Cobro por Fecha Real"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                        <template>
                          <p>
                            Si se selecciona, se calcula la Fecha de Débito en
                            base al día especificado el Día de Cobro
                          </p>
                          <p>
                            Si NO se selecciona, se calcula la Fecha de Débito
                            en base al día hábil especificado el Día de Cobro
                          </p>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="filtro.calcularFechaDebitoAFuturo"
                    label="Calcular Fecha de Débito a Futuro"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                        <template>
                          <p>
                            Si se selecciona, se calcula la Fecha de Débito
                            considerando el Vencimiento de la Cuota como si
                            fuese del mes próximo
                          </p>
                          <p>
                            Si NO se selecciona, se calcula la Fecha de Débito
                            tomando el Vencimiento real de la Cuota
                          </p>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- PROCESO EXCEL CON IMPORTES -->
          <v-expansion-panel>
            <v-expansion-panel-header v-slot="{}">
              <v-row>
                <v-col>Archivo Excel con Importes</v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row align="center">
                <v-col>
                  <v-file-input
                    v-model="archivoProcesoOperaciones"
                    placeholder="Seleccione el archivo Excel"
                    label="Archivo con Créditos e Importes"
                    prepend-icon="mdi-paperclip"
                  >
                  </v-file-input>
                </v-col>
                <v-col>
                  <v-btn @click="cargarListaOperacionesDeExcel()">
                    Cargar Archivo
                  </v-btn>
                </v-col>

                <v-spacer />
              </v-row>

              <v-row v-if="archivoProcesoOperaciones != null">
                <v-col>
                  <v-chip label color="warning">
                    Presione Cargar Archivo para procesar los datos
                  </v-chip>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-card-actions>
        <v-row dense>
          <v-spacer></v-spacer>
          <v-col cols="2" lg="1">
            <v-btn color="success" @click="getItems()" :disabled="loading">
              Buscar
              <v-icon>search</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-layout row>
      <v-flex>
        <v-card>
          <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
            <v-icon>list</v-icon>
            <v-toolbar-title class="font-weight-light"
              >Resultados</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-data-table
            dense
            :show-select="records.length > 0"
            :headers="headers"
            :items="records"
            v-model="selectedCuotas"
            item-key="id"
            :loading="loading"
            :footer-props="footer"
            class="elevation-1"
          >
            <template v-slot:no-data>
              <v-alert
                v-if="!primeraBusquedaRealizada"
                :value="true"
                icon="info"
                dense
              >
                Ingrese los filtros para realizar la búsqueda
              </v-alert>
              <v-alert v-else :value="true" color="grey" icon="warning" dense>
                No se encontraron datos
              </v-alert>
            </template>

            <template v-slot:header.data-table-select="{ on, props }">
              <v-checkbox
                @change="selectAllChanged"
                color="purple"
                v-bind="props"
                v-on="on"
              ></v-checkbox>
            </template>

            <template
              v-if="selectedCuotas.length > 0"
              v-slot:body.append="{ headers }"
            >
              <tr>
                <td
                  :colspan="headers.length"
                  class="text-xs-right body-2 green"
                >
                  Registros Seleccionados: {{ selectedCuotas.length }}
                </td>
              </tr>
              <tr>
                <td
                  :colspan="headers.length"
                  class="text-xs-right body-2 light-green"
                >
                  Importe:
                  {{
                    selectedCuotas.length > 0
                      ? selectedCuotas
                          .map((i) => i.importeCuota)
                          .reduce((a, b) => a + b, 0)
                      : 0 | currency
                  }}
                </td>
              </tr>
            </template>

            <template v-slot:item="{ item, isSelected, select }">
              <tr>
                <td>
                  <v-simple-checkbox
                    class="caption"
                    color="green"
                    :value="isSelected"
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td>
                  <app-acciones-comunes
                    :documento="item.documento"
                    :personaId="item.personaId"
                  >
                  </app-acciones-comunes>
                </td>
                <td class="text-xs-left caption">{{ item.nombre }}</td>
                <td class="text-xs-left caption">{{ item.documento }}</td>

                <td class="text-xs-left caption">
                  <v-chip v-if="item.tipoDeuda == 1" x-small color="green" dark
                    >CR
                  </v-chip>
                  <v-chip v-if="item.tipoDeuda == 2" x-small color="blue" dark
                    >ACU
                  </v-chip>

                  {{ item.numeroCredito }}
                </td>
                <td class="text-xs-left caption">
                  {{ item.cuota }}/{{ item.cuotas }}
                </td>
                <td class="text-xs-left caption">{{ item.diaCobro }}</td>
                <td class="text-xs-left caption">
                  {{ item.vencimiento | dateParse() | dateFormat("DD-MM-YY") }}
                </td>

                <td class="text-xs-left caption">
                  <v-edit-dialog
                    :return-value.sync="item.fechaDebito"
                    large
                    persistent
                  >
                    <div>{{ item.fechaDebito }}</div>
                    <template v-slot:input>
                      <div class="mt-4 title">Sobreescribir Importe</div>
                    </template>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.fechaDebito"
                        type="date"
                        label="Edit"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>

                <!-- <td class ="text-xs-left caption">{{ item.importeCuota | currency}}</td> -->
                <td class="text-xs-left caption">
                  <v-edit-dialog
                    :return-value.sync="item.importeCuota"
                    large
                    persistent
                  >
                    <div>{{ item.importeCuota | currency }}</div>
                    <template v-slot:input>
                      <div class="mt-4 title">Sobreescribir Importe</div>
                    </template>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.importeCuota"
                        label="Edit"
                        single-line
                        counter
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-xs-left caption">
                  {{
                    item.vencimientoTarjeta | dateParse() | dateFormat("MM-YY")
                  }}
                </td>
                <td class="text-xs-left caption" v-if="formatoEnvioId == 1001">
                  {{ item.operacionCarcred }}
                </td>
                <td class="text-xs-left caption" v-if="formatoEnvioId == 16">
                  {{ item.tokenTarjeta }}
                </td>

                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.estudios"
                >
                  {{ item.estudio }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.provincia"
                >
                  {{ item.provincia }}
                </td>

                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.vectorAtraso"
                >
                  {{ item.vectorAtraso }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.vectorAtraso"
                >
                  {{ item.vectorAtrasoCredito }}
                </td>

                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.empleador"
                >
                  {{ item.cuitEmpleador }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.empleador"
                >
                  {{ item.empleador }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.canalVenta"
                >
                  {{ item.canalVenta }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.importeCuota"
                >
                  {{ item.importeCuota | currency }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.importePunitorios"
                >
                  {{ item.importePunitorios | currency }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.importeCargos"
                >
                  {{ item.importeCargos | currency }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.saldoClub"
                >
                  {{ item.saldoClub | currency }}
                </td>

                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.sucursalBanco"
                >
                  <v-edit-dialog
                    :return-value.sync="item.sucursalBanco"
                    large
                    persistent
                  >
                    <div>{{ item.sucursalBanco }}</div>
                    <template v-slot:input>
                      <div class="mt-4 title">Sobreescribir Sucursal Banco</div>
                    </template>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.sucursalBanco"
                        label="Edit"
                        single-line
                        counter
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>

                <!-- última generacion -->
                <td
                  class="text-xs-left caption"
                  v-if="
                    estadoColumnasAdicionales.ultimaGeneracion &&
                    item.fechaUltimaGeneracion == null
                  "
                >
                  -
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="
                    estadoColumnasAdicionales.ultimaGeneracion &&
                    item.fechaUltimaGeneracion != null
                  "
                >
                  {{
                    item.fechaUltimaGeneracion
                      | dateParse()
                      | dateFormat("DD-MM-YY HH:mm")
                  }}
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.ultimaGeneracion"
                >
                  {{ item.formatoUltimaGeneracion }}
                </td>

                <!-- último impacto -->
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.impactos"
                >
                  <v-chip
                    v-if="item.cantidadImpactos > 0"
                    small
                    dark
                    color="green"
                    @click="verResultadosEnvios(item, true, false)"
                    >{{ item.cantidadImpactos }}</v-chip
                  >
                </td>

                <td
                  class="text-xs-left caption"
                  v-if="
                    estadoColumnasAdicionales.impactos &&
                    item.fechaUltimoImpacto == null
                  "
                >
                  -
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="
                    estadoColumnasAdicionales.impactos &&
                    item.fechaUltimoImpacto != null
                  "
                >
                  {{
                    item.fechaUltimoImpacto
                      | dateParse()
                      | dateFormat("DD-MM-YY")
                  }}
                </td>

                <!-- último rechazo -->
                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.rechazos"
                >
                  <v-chip
                    v-if="item.cantidadRechazos > 0"
                    small
                    dark
                    color="red"
                    @click="verResultadosEnvios(item, false, true)"
                    >{{ item.cantidadRechazos }}</v-chip
                  >
                </td>

                <td
                  class="text-xs-left caption"
                  v-if="
                    estadoColumnasAdicionales.rechazos &&
                    item.fechaUltimoRechazo == null
                  "
                >
                  -
                </td>
                <td
                  class="text-xs-left caption"
                  v-if="
                    estadoColumnasAdicionales.rechazos &&
                    item.fechaUltimoRechazo != null
                  "
                >
                  {{
                    item.fechaUltimoRechazo
                      | dateParse()
                      | dateFormat("DD-MM-YY")
                  }}
                </td>

                <td
                  class="text-xs-left caption"
                  v-if="estadoColumnasAdicionales.rechazos"
                >
                  {{ item.motivoUltimoRechazo }}
                </td>
              </tr>
            </template>
          </v-data-table>

          <v-card-text>
            <v-expansion-panels dense>
              <v-expansion-panel dense>
                <v-expansion-panel-header v-slot="{}" dense>
                  <v-row align="center" no-gutters>
                    <v-col>
                      <v-icon color="green">add </v-icon>
                    </v-col>
                    <v-col>Ver Más Columnas</v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content dense>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        label="Info. Impactos"
                        v-model="estadoColumnasAdicionales.impactos"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Info. Rechazos"
                        v-model="estadoColumnasAdicionales.rechazos"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Ultima Generacion"
                        v-model="estadoColumnasAdicionales.ultimaGeneracion"
                      ></v-checkbox>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        label="Estudio"
                        v-model="estadoColumnasAdicionales.estudios"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Provincia"
                        v-model="estadoColumnasAdicionales.provincia"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Vector Atraso"
                        v-model="estadoColumnasAdicionales.vectorAtraso"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Empleador"
                        v-model="estadoColumnasAdicionales.empleador"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Canal de Venta"
                        v-model="estadoColumnasAdicionales.canalVenta"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        label="Imp. Punitorios"
                        v-model="estadoColumnasAdicionales.importePunitorios"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Imp. Cargos"
                        v-model="estadoColumnasAdicionales.importeCargos"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Saldo Club"
                        v-model="estadoColumnasAdicionales.saldoClub"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Sucursal Banco"
                        v-model="estadoColumnasAdicionales.sucursalBanco"
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Importe Cuota"
                        v-model="estadoColumnasAdicionales.importeCuota"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-card-actions>
            <v-row align="center">
              <v-col cols="4">
                <span v-if="formatoEnvioId" class="title"
                  >&nbsp;&nbsp; Formato Seleccionado:
                  {{
                    formatosEnvio.find((f) => f.id == formatoEnvioId)
                      .descripcion
                  }}</span
                >

                <div v-if="formatoEnvioId == 1001">
                  <v-btn color="green" @click="preProcesarEnvioApiCardCred"
                    >Pre Procesar Casos</v-btn
                  >
                </div>
              </v-col>

              <v-col
                cols="2"
                v-if="
                  formatosEnvio.find((f) => f.id == formatoEnvioId) != null &&
                  formatosEnvio.find((f) => f.id == formatoEnvioId)
                    .requiereFechaRendicion
                "
              >
                <v-text-field
                  v-model="filtro.fechaRendicion"
                  label="Fecha Rendición"
                  type="date"
                  prepend-icon="event"
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                v-if="
                  formatosEnvio.find((f) => f.id == formatoEnvioId) != null &&
                  formatosEnvio.find((f) => f.id == formatoEnvioId)
                    .requiereFechaPresentacion
                "
              >
                <v-text-field
                  v-model="filtro.fechaPresentacion"
                  label="Fecha Primer Impacto"
                  type="date"
                  prepend-icon="event"
                ></v-text-field>
              </v-col>

              <v-col
                cols="1"
                v-if="
                  formatosEnvio.find((f) => f.id == formatoEnvioId) != null &&
                  formatoEnvioId == 1001
                "
              >
                <v-text-field
                  v-model="filtro.horaImpacto"
                  label="Hora Impacto"
                ></v-text-field>
              </v-col>
              <v-col
                cols="1"
                v-if="
                  formatosEnvio.find((f) => f.id == formatoEnvioId) != null &&
                  formatoEnvioId == 1001
                "
              >
                <v-text-field
                  v-model="filtro.diasBarrido"
                  label="Días Barrido"
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>
              <v-col cols="2" v-if="formatoEnvioId">
                <v-switch
                  label="Generar Log"
                  :disabled="true"
                  v-model="generarLog"
                  color="indigo"
                  :hint="
                    generarLog
                      ? 'Se genera respaldatorio luego de descarga'
                      : 'No se genera reporte respaldatorio'
                  "
                  persistent-hint
                ></v-switch>
              </v-col>

              <v-col
                cols="2"
                v-if="
                  formatoEnvioId &&
                  !formatosEnvio
                    .find((f) => f.id == formatoEnvioId)
                    .descripcion.includes('API')
                "
              >
                <v-btn
                  @click="generarArchivo"
                  color="indigo"
                  dark
                  :disabled="loading"
                  >Generar Archivo</v-btn
                >
              </v-col>

              <v-col cols="2" v-if="formatoEnvioId">
                <v-btn
                  @click="procesarEnvioApi"
                  color="indigo"
                  dark
                  :disabled="
                    loading ||
                    (formatoEnvioId == 1001 && recordsPreProcesoApi.length == 0)
                  "
                  >Procesar Envio Api</v-btn
                >
                <div
                  v-if="
                    formatoEnvioId == 1001 && recordsPreProcesoApi.length == 0
                  "
                >
                  Debe PreProcesar los casos antes del Envío
                </div>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions>
            <v-row align="center">
              <v-spacer></v-spacer>
              <v-col
                cols="2"
                v-if="
                  formatosEnvio.find((f) => f.id == formatoEnvioId) != null &&
                  formatoEnvioId == 1001
                "
              >
                <v-text-field
                  v-model="filtro.descuentoExcedeDisponible"
                  label="Dto.Excedente Dispo."
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                v-if="
                  formatosEnvio.find((f) => f.id == formatoEnvioId) != null &&
                  formatoEnvioId == 1001
                "
              >
                <v-text-field
                  v-model="filtro.descuentoSinFondos"
                  label="Dto.Sin Fondos."
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>

          <v-card-actions>
            <v-row v-if="ParametrosGenerales.conexionSms && formatoEnvioId">
              <v-col cols="2">
                <v-switch
                  label="Enviar SMS"
                  v-model="enviarSms"
                  color="indigo"
                ></v-switch>
              </v-col>

              <v-col cols="2" v-if="enviarSms">
                <v-autocomplete
                  v-model="modeloSmsId"
                  :items="listModelosSms"
                  no-data-text="No hay modelos cargados para gestiones de Débitos por CBU"
                  item-text="descripcion"
                  item-value="id"
                  label="Modelo SMS"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row dense>
              <v-col cols="4" lg="3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      dark
                      color="brown"
                      v-on="on"
                      @click="showHistorial = true"
                    >
                      Ver Historial de Envíos&nbsp;
                      <v-icon>date_range</v-icon>
                    </v-btn>
                  </template>
                  <span>Se muestra el historial de Envíos realizados</span>
                </v-tooltip>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="showHistorial"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Historial de Envíos Realizados</v-card-title
        >
        <v-card-text>
          <v-row dense>
            <v-col cols>
              <v-autocomplete
                v-model="formatoEnvioLogId"
                :items="formatoEnvio"
                autocomplete="disabled"
                item-text="descripcion"
                item-value="id"
                label="Archivo de"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <app-selector-periodos
                row
                v-on:update-periodo="periodoLote = $event"
              ></app-selector-periodos>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn dark color="blue" @click="loadLogEnvios">
              Consultar&nbsp;
            </v-btn>
          </v-row>

          <!-- <v-flex right>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar por Nombre"
                    single-line
                    hide-details
                ></v-text-field>
              </v-flex> -->

          <v-data-table
            dense
            :headers="headersLog"
            :items="recordsLog"
            :server-items-length="totalItemsLog"
            :loading="loadingLog"
            :options.sync="optionsLog"
            v-model="selectedRowLog"
            :footer-props="{ itemsPerPageOptions: optionsLog.rowsPerPageItems }"
            show-expand
            :expanded.sync="expanded"
          >
            <template slot="no-data">
              <v-alert :value="true" color="grey" icon="warning">
                No se encontraron datos
              </v-alert>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">
                  {{ item.empresaId == 1 ? "Argen" : "Finadi" }}
                </td>
                <td class="text-xs-left caption">{{ item.lote }}</td>
                <td class="text-xs-left caption">
                  {{ item.fecha | dateParse() | dateFormat("DD-MM-YY hh:mm") }}
                </td>
                <td class="text-xs-left caption">{{ item.responsable }}</td>
                <td class="text-xs-left caption">{{ item.formato }}</td>
                <td class="text-center caption">
                  {{ item.cantidadRegistros }}
                </td>
                <td class="text-right caption">
                  {{ item.importeTotal | currency }}
                </td>

                <td class="text-xs-left">
                  <v-icon small @click="expandLogDetalle(item)">info</v-icon>
                  <v-icon small @click="printLog(item)">print</v-icon>
                </td>
              </tr>
            </template>

            <template v-slot:expanded-item="{ headers }">
              <td :colspan="headers.length">
                <v-data-table
                  dense
                  :headers="headersLogDetalle"
                  :items="recordsLogDetalle"
                  :server-items-length="totalItemsLogDetalle"
                  :loading="loadingLogDetalle"
                  :options.sync="optionsLogDetalle"
                  v-model="selectedRowLogDetalle"
                  :footer-props="{
                    itemsPerPageOptions: optionsLogDetalle.rowsPerPageItems,
                  }"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-xs-left caption">{{ item.nombre }}</td>
                      <td class="text-xs-left caption">{{ item.numero }}</td>
                      <td class="text-xs-left caption">{{ item.cuota }}</td>
                      <td class="text-xs-left caption">
                        {{ item.importeCuota | currency }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.fechaDebito
                            | dateParse()
                            | dateFormat("DD-MM-YY")
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.referenciaEnvioId }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text dark class="green" @click.native="showHistorial = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showResultadoProceso"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Resultado del Proceso</v-card-title>
        <v-card-subtitle
          >Los pagos se procesan desde Importación de Pagos</v-card-subtitle
        >
        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table
                dense
                :headers="headersProcesoApi"
                :items="recordsProcesoApi"
                class="elevation-1"
                item-key="id"
              >
                <!--
                      :footer-props="footer" 
                      :rows-per-page="pagination.itemsPerPage"
                      :options.sync ="pagination" -->
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-xs-left caption">
                      <tr>
                        {{
                          item.infoPersona
                        }}
                      </tr>
                      <tr>
                        {{
                          item.infoDeuda ? item.infoDeuda : ""
                        }}
                      </tr>
                    </td>

                    <td class="text-xs-left caption">
                      {{ item.importe | currency }}
                    </td>
                    <td class="text-xs-left caption">{{ item.resultado }}</td>
                    <td class="text-xs-left caption">
                      {{ item.imputacionDescripcion }}
                    </td>
                    <td class="text-xs-left caption">{{ item.errores }}</td>
                    <td class="text-xs-left caption">
                      {{ item.referenciaEnvioId }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            dark
            class="green"
            @click.native="showResultadoProceso = false"
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <!-- <v-btn dark color="success" @click.native="procesarPagos">
                Procesar Pagos
              </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showResultadoPreProceso"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Casos a Enviar por API</v-card-title>
        <v-card-subtitle>Los casos se hay agrupado por cliente</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table
                dense
                :headers="headersPreProcesoApi"
                :items="recordsPreProcesoApi"
                class="elevation-1"
                item-key="id"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-xs-left caption">
                      {{ item.nombre }}
                    </td>
                    <td class="text-xs-left caption">
                      {{ item.documento }}
                    </td>

                    <td class="text-xs-left caption">
                      {{ item.importeADebitar | currency }}
                    </td>

                    <td class="text-xs-left caption">{{ item.masInfo }}</td>
                    <td class="text-xs-left caption">
                      {{ item.operacionCarcred }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            dark
            class="green"
            @click.native="showResultadoPreProceso = false"
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <!-- <v-btn dark color="success" @click.native="procesarPagos">
                Procesar Pagos
              </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-loading :loading="loading"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";
import { format } from "date-fns";

export default {
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      records: [], // registros
      headersLog: [
        // definición de columnas
        { text: "Empresa", value: "empresaId", sortable: false },
        { text: "Lote", value: "lote" },
        { text: "Fecha", value: "fecha" },
        { text: "Responsable", value: "name" },
        { text: "Formato", value: "formato" },
        { text: "# Registros", value: "cantidadRegistros", sortable: false },
        {
          text: "$ Total",
          value: "importeTotal",
          sortable: false,
          align: "end",
        },
        { text: "", value: "data-table-expand" },
      ],
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [25, 50, 100, 500],
        showCurrentPage: true,
      },
      recordsLog: [], // registros
      loadingLog: false,
      totalItemsLog: 0, // va afuera de options
      optionsLog: {
        // definición de paginación
        sortDesc: [true],
        sortBy: ["lote"],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      expanded: [],
      selectedRowLog: [],
      headersLogDetalle: [
        // definición de columnas
        { text: "Nombre", value: "lote" },
        { text: "Crédito Nº", value: "descripcion" },
        { text: "Cuota", value: "name" },
        { text: "$ Importe", value: "formato" },
        { text: "Fec.Débito", value: "cantidadRegistros", sortable: false },
        { text: "Nº Referencia", value: "referenciaEnvioId", sortable: false },
      ],
      recordsLogDetalle: [], // registros
      loadingLogDetalle: false,
      totalItemsLogDetalle: 0, // va afuera de options
      optionsLogDetalle: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      selectedRowLogDetalle: [],
      allCuotasSelected: false,
      generarLog: true,
      enviarSms: false,
      selectedCuotas: [],
      showHistorial: false,
      filtro: {
        empresaId: 1,
        productoId: 0,
        canalVentaId: 0,
        archivoExcel: {},
        ultimaGeneracionDesde: "",
        ultimaGeneracionHasta: "",
        ultimaGeneracionInversa: false,
        cuitEmpleador: 0,
        excluirCuitEmpleador: false,
        planes: [],
        productos: [],
        bancos: [],
        excluirBancos: false,
        radiosArchivoExcel: "Ignorar",
        diaCobroDesde: 0,
        diaCobroHasta: 0,
        operacionesFiltro: { id: "", cantidad: 0 },
        estudioId: "0",
        envioEstudioDesde: "",
        envioEstudioHasta: "",
        vtoDesde: format(new Date(), "YYYY-MM-DD"),
        vtoHasta: format(new Date(), "YYYY-MM-DD"),
        fechaCobroDesde: format(new Date(), "YYYY-MM-DD"),
        fechaCobroHasta: format(new Date(), "YYYY-MM-DD"),
        liquidacionDesde: format(new Date(), "YYYY-MM-DD"),
        liquidacionHasta: format(new Date(), "YYYY-MM-DD"),
        radiosAcuerdo: "SinAcuerdo",
        radiosEstudio: "NoEnEstudio",
        radiosRechazo: "Todos",
        radiosTarjeta: "TarjetaActiva",
        diaCobroPorFechaReal: false,
        calcularFechaDebitoAFuturo: false,
        reciclaje: false,
        fechaReciclaje: "",
        dividirCuotas: false,
        dividirCuotasIguales: false,
        dividirCuotasEn: 1,
        dividirCuotasMaximo: 0,
        enviarPrimerParte: false,
        diferirFechaDebito: false,
        diasDiferirFechaDebito: 0,
        filtrarPorVector: false,
        vectorDesde: 0,
        vectorHasta: 0,
        soloPrimerVencimiento: false,
        queGenerar: "cuotas",
        tasaPunitorios: 0,
        horaImpacto: 1,
        diasBarrido: 1,
        descuentoExcedeDisponible: 0,
        descuentoSinFondos: 0,
        buscarDeTablaAImpactarNormales: true,
        preLoteId: "",
      },
      empresas: [],
      canalesVenta: [],
      productos: [],
      planes: [],
      estudios: [],
      preLotes: [],
      bancos: [],
      formatosEnvio: [],
      formatoEnvio: [],
      periodoLote: { id: 1 },
      formatoSeleccionado: { restringeEntidadFinanciera: false },
      listModelosSms: [],
      excelFiltro: {},
      formatoEnvioId: 0,
      formatoEnvioLogId: 0,
      modeloSmsId: 0,
      generarPreLote: false,
      archivoFiltroOperaciones: [],
      archivoProcesoOperaciones: [],
      estadoColumnasAdicionales: {
        estudios: false,
        provincia: false,
        vectorAtraso: false,
        empleador: false,
        canalVenta: false,
        importePunitorios: false,
        importeCargos: false,
        sucursalBanco: false,
        saldoClub: false,
        importeCuota: false,
        impactos: false,
        rechazos: false,
        ultimaGeneracion: false,
      },
      showResultadoProceso: false,
      showResultadoPreProceso: false,
      recordsProcesoApi: [],
      recordsPreProcesoApi: [],
      headersPreProcesoApi: [
        // definición de columnas
        { text: "Débito a", value: "nombre" },
        { text: "Documento", value: "documento" },
        { text: "Importe", value: "importeADebitar", width: 110 },
        { text: "Créditos Incluidos", value: "masInfo" },
        { text: "Cte.CardCred", value: "masInfo" },
      ],
      headersProcesoApi: [
        // definición de columnas
        { text: "Débito a", value: "infoPersona" },
        { text: "Importe", value: "importeDebitado", width: 110 },
        { text: "Resultado", value: "resultado" },
        { text: "Imputación", value: "imputacionDescripcion" },
        { text: "Errores", value: "errores" },
        { text: "Nº Referencia", value: "referenciaId", width: 110 },
      ],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadCanalesVenta();
    this.loadProductos();
    this.loadPlanes();
    this.loadFormatosEnvio();
    this.loadFormatoEnvio();
    this.loadEntidadesFinancieras();
    this.loadEstudios();
    this.loadPreLotes();
    if (this.ParametrosGenerales.conexionSms) {
      this.loadModelosSMS();
    }
  },
  watch: {
    search() {
      this.getItems();
    },
    optionsLog: {
      handler() {
        this.loadLogEnvios();
      },
      deep: true,
    },
    optionsLogDetalle: {
      handler() {
        this.loadLogEnviosDetalle(this.expanded[0]);
      },
      deep: true,
    },
    // showHistorial() {
    //   if (this.showHistorial) {
    //     this.loadLogEnvios();
    //   }
    // },
    "filtro.empresaId"() {
      this.loadPlanes();
    },
    "filtro.radiosEstudio"() {
      if (this.filtro.radiosEstudio == "NoEnEstudio")
        this.estadoColumnasAdicionales.estudios = false;
      else this.estadoColumnasAdicionales.estudios = true;
    },
    "filtro.queGenerar"() {
      if (
        this.filtro.queGenerar == "punitoriofijo" ||
        this.filtro.queGenerar == "cuotas+punitorios"
      )
        this.estadoColumnasAdicionales.importePunitorios = true;
      else this.estadoColumnasAdicionales.importePunitorios = false;
    },
    formatoEnvioId() {
      this.formatoSeleccionado = { restringeEntidadFinanciera: false };
      if (!this.formatoEnvioId) return;

      var formato = this.formatosEnvio.find((f) => f.id == this.formatoEnvioId);
      if (!formato) return;
      this.formatoSeleccionado = formato;
    },
    archivoFiltroOperaciones() {
      if (this.archivoFiltroOperaciones == null)
        this.filtro.operacionesFiltro = { id: "", cantidad: 0 };
    },
  },
  computed: {
    ...mapGetters([
      "getActionFromLink",
      "error",
      "user",
      "ParametrosGenerales",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    todosLosPlanesMarcados() {
      return this.filtro.planes.length === this.planes.length;
    },
    algunosPlanesMarcados() {
      return this.filtro.planes.length > 0 && !this.todosLosPlanesMarcados;
    },
    iconPlanes() {
      if (this.todosLosPlanesMarcados) return "mdi-close-box";
      if (this.algunosPlanesMarcados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    // todasLasCuotasMarcadas () {
    //   return this.selectedCuotas.length === this.records.length
    // },
    // algunasCuotasMarcadas () {
    //   return this.selectedCuotas > 0 && !this.todasLasCuotasMarcadas
    // },
    headers() {
      var headers = [
        // definición de columnas
        { text: "Ver", value: "accion", width: 70, sortable: false },
        { text: "Solicitante", value: "nombre" },
        { text: "Documento", value: "documento" },
        { text: "Deuda", value: "numeroCredito" },
        { text: "Cuota", value: "cuota" },
        { text: "Dia Cobro", value: "diaCobro" },
        { text: "Vencimiento", value: "vencimiento" },
        { text: "Fecha Débito", value: "fechaDebito" },
        { text: "Saldo Cuota", value: "importeCuota" },
        { text: "Vencimiento Tarjeta", value: "vencimientoTarjeta" },
      ];

      if (
        this.formatoEnvioId == 1001 &&
        !this.filtro.buscarDeTablaAImpactarNormales
      )
        headers.push({ text: "Op.CardCred", value: "operacionCarcred" });

      if (
        this.formatoEnvioId == 1001 &&
        this.filtro.buscarDeTablaAImpactarNormales
      )
        headers.push({ text: "Cte.CardCred", value: "operacionCarcred" });

      if (this.formatoEnvioId == 16)
        headers.push({ text: "Token", value: "tokenTarjeta" });

      if (this.estadoColumnasAdicionales.estudios)
        headers.push({ text: "Estudio", value: "estudio" });

      if (this.estadoColumnasAdicionales.provincia)
        headers.push({ text: "Provincia", value: "provincia" });

      if (this.estadoColumnasAdicionales.vectorAtraso) {
        headers.push({ text: "V.A. ", value: "vectorAtraso", width: 80 });
        headers.push({
          text: "V.A. Cred.",
          value: "vectorAtrasoCredito",
          width: 80,
        });
      }

      if (this.estadoColumnasAdicionales.empleador) {
        headers.push({ text: "Empleador", value: "empleador" });
        headers.push({ text: "CUIT Empl.", value: "cuitEmpleador" });
      }

      if (this.estadoColumnasAdicionales.canalVenta)
        headers.push({ text: "Canal Venta", value: "canalVenta" });

      if (this.estadoColumnasAdicionales.importeCuota)
        headers.push({ text: "Imp. Cuota", value: "importeCuota" });

      if (this.estadoColumnasAdicionales.importePunitorios)
        headers.push({ text: "Imp. Punitorios", value: "importePunitorios" });

      if (this.estadoColumnasAdicionales.importeCargos)
        headers.push({ text: "Imp. Cargos", value: "importeCargos" });

      if (this.estadoColumnasAdicionales.saldoClub)
        headers.push({ text: "Saldo Club", value: "saldoClub" });

      if (this.estadoColumnasAdicionales.sucursalBanco)
        headers.push({ text: "Suc. Banco", value: "sucursalBanco" });

      if (this.estadoColumnasAdicionales.ultimaGeneracion) {
        headers.push({
          text: "Ult. Generación",
          value: "fechaUltimaGeneracion",
        });
        headers.push({ text: "Formato", value: "formatoUltimaGeneracion" });
      }

      if (this.estadoColumnasAdicionales.impactos) {
        headers.push({ text: "# Impactos", value: "cantidadImpactos" });
        headers.push({ text: "Ult. Impacto", value: "fechaUltimoImpacto" });
      }

      if (this.estadoColumnasAdicionales.rechazos) {
        headers.push({ text: "# Rechazos", value: "cantidadRechazos" });
        headers.push({ text: "Ult. Rechazo", value: "fechaUltimoRechazo" });
        headers.push({ text: "Motivo", value: "motivoUltimoRechazo" });
      }

      return headers;
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    selectAllChanged(toggle) {
      this.selectedCuotas = [];
      if (toggle) {
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];

          this.selectedCuotas.push(element);
        }
      }
    },
    async expandLogDetalle(item) {
      if (this.expanded.length == 0 || item != this.expanded[0]) {
        this.expanded = [];
        this.loadLogEnviosDetalle(item);
        this.expanded.push(item);
      } else {
        this.expanded = [];
      }
    },
    async getItems() {
      Vue.$log.debug(this.filtro);

      this.$validator.reset();

      let filter = this.filtro;

      if (filter.reciclaje && filter.fechaReciclaje == "") {
        this.alertWarning("Por favor, especifique la fecha de reciclaje");
        return;
      }

      if (filter.diferirFechaDebito && filter.diasDiferirFechaDebito <= 0) {
        this.alertWarning(
          "Por favor, especifique la cantidad de días a diferir el débito"
        );
        return;
      } else if (!filter.diferirFechaDebito) {
        filter.diasDiferirFechaDebito = 0;
      }

      if (!filter.filtrarDiaCobro) {
        filter.diaCobroDesde = 0;
        filter.diaCobroHasta = 0;
      }

      if (!filter.filtrarFechaUltimaGeneracion) {
        filter.ultimaGeneracionDesde = "";
        filter.ultimaGeneracionHasta = "";
      }

      if (!filter.filtrarFechaLiquidacion) {
        filter.liquidacionDesde = "";
        filter.liquidacionHasta = "";
      }

      if (filter.filtrarFechaLiquidacionPreBCRA) {
        filter.liquidacionDesde = "";
        filter.liquidacionHasta =
          this.$moment("2020-02-19").format("YYYY-MM-DD");
      }

      if (filter.soloPrimerVencimiento) {
        filter.filtrarPorVector = false;
      }

      this.loading = true;
      let idCanalesVenta = filter.canalVentaId.toString();

      //Si se eligió TODOS ( y no tiene acceso a todos los canaes) armo un string con todos los canales de venta habilitados para el usuario.
      if (
        filter.canalVentaId === 0 &&
        !this.$store.state.user.accesoTodosCanalesVenta
      ) {
        for (var i = 0; i < this.canalesVenta.length; i++) {
          if (i === 0) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += "," + this.canalesVenta[i].id;
        }
      } else {
        idCanalesVenta = "0";
      }

      let idEstudios = filter.estudioId;
      let operacionesFiltro = this.filtro.operacionesFiltro;

      //var soloSinDebitoEnCuenta = filter.radiosDebitoEnCuenta == 'SoloSinDebitoEnCuenta';
      var tarjetaActiva = filter.radiosTarjeta == "TarjetaActiva";
      var tarjetaInactiva = filter.radiosTarjeta == "TarjetaInactiva";
      var conAcuerdo =
        filter.radiosAcuerdo == "ConAcuerdo" || filter.radiosAcuerdo == "Todos";
      var sinAcuerdo =
        filter.radiosAcuerdo == "SinAcuerdo" || filter.radiosAcuerdo == "Todos";
      var conRechazo = filter.radiosRechazo == "ConRechazo";
      var sinRechazo = filter.radiosRechazo == "SinRechazo";
      var enEstudio = filter.radiosEstudio == "EnEstudio";
      var noEnEstudio = filter.radiosEstudio == "NoEnEstudio";
      var ignorarFiltroOperaciones = filter.radiosArchivoExcel == "Ignorar";
      var soloOperacionesFiltro =
        filter.radiosArchivoExcel == "SoloCasosFiltro";
      var excluirOperacionesFiltro =
        filter.radiosArchivoExcel == "ExcluirCasosFiltro";

      try {
        var result = await http.get(
          "archivosDebito/getcuotasarchivodebitotarjeta?empresaId=" +
            filter.empresaId +
            "&vtoDesde=" +
            filter.vtoDesde +
            "&vtoHasta=" +
            filter.vtoHasta +
            "&canalesVenta=" +
            idCanalesVenta +
            "&productoId=" +
            filter.productoId +
            "&planes=" +
            filter.planes +
            "&bancos=" +
            filter.bancos +
            "&excluirBancos=" +
            filter.excluirBancos +
            "&diaCobroDesde=" +
            filter.diaCobroDesde +
            "&diaCobroHasta=" +
            filter.diaCobroHasta +
            "&cuitEmpleador=" +
            filter.cuitEmpleador +
            "&excluirCuitEmpleador=" +
            filter.excluirCuitEmpleador +
            "&tarjetaActiva=" +
            tarjetaActiva +
            "&tarjetaInactiva=" +
            tarjetaInactiva +
            "&conAcuerdo=" +
            conAcuerdo +
            "&sinAcuerdo=" +
            sinAcuerdo +
            "&enEstudio=" +
            enEstudio +
            "&noEnEstudio=" +
            noEnEstudio +
            "&estudios=" +
            idEstudios +
            "&envioEstudioDesde=" +
            filter.envioEstudioDesde +
            "&envioEstudioHasta=" +
            filter.envioEstudioHasta +
            "&filtroOperaciones=" +
            operacionesFiltro.id +
            "&ignorarFiltroOperaciones=" +
            ignorarFiltroOperaciones +
            "&soloOperacionesFiltro=" +
            soloOperacionesFiltro +
            "&excluirOperacionesFiltro=" +
            excluirOperacionesFiltro +
            "&soloConRechazo=" +
            conRechazo +
            "&soloSinRechazo=" +
            sinRechazo +
            "&ultimaGeneracionDesde=" +
            filter.ultimaGeneracionDesde +
            "&ultimaGeneracionHasta=" +
            filter.ultimaGeneracionHasta +
            "&ultimaGeneracionInversa=" +
            filter.ultimaGeneracionInversa +
            "&diaCobroPorFechaReal=" +
            filter.diaCobroPorFechaReal +
            "&calcularFechaDebitoAFuturo=" +
            filter.calcularFechaDebitoAFuturo +
            "&reciclaje=" +
            filter.reciclaje +
            "&fechaReciclaje=" +
            filter.fechaReciclaje +
            "&dividirCuotas=" +
            filter.dividirCuotas +
            "&dividirCuotasEn=" +
            filter.dividirCuotasEn +
            "&enviarPrimerParte=" +
            filter.enviarPrimerParte +
            "&diferirFechaDebito=" +
            filter.diferirFechaDebito +
            "&diasDiferirFechaDebito=" +
            filter.diasDiferirFechaDebito +
            "&filtrarPorVector=" +
            filter.filtrarPorVector +
            "&vectorDesde=" +
            filter.vectorDesde +
            "&vectorHasta=" +
            filter.vectorHasta +
            "&soloPrimerVencimientoImpago=" +
            filter.soloPrimerVencimiento +
            "&queGenerar=" +
            filter.queGenerar + // cuotas o punitorios
            "&tasaPunitorios=" +
            filter.tasaPunitorios + // cuotas o punitorios
            "&liquidacionDesde=" +
            filter.liquidacionDesde +
            "&liquidacionHasta=" +
            filter.liquidacionHasta +
            "&formatoDebitoId=" +
            this.formatoEnvioId +
            "&buscarDeImpactarNormales=" +
            filter.buscarDeTablaAImpactarNormales +
            "&preLoteId=" +
            filter.preLoteId +
            "&fechaCobroDesde=" +
            filter.fechaCobroDesde +
            "&fechaCobroHasta=" +
            filter.fechaCobroHasta
        );

        Vue.$log.debug(result);

        this.selectedCuotas = []; // limpio las cuotas seleccionadas
        this.recordsPreProcesoApi = [];

        this.records = result.list;

        for (let i = 0; i < this.records.length; i++) {
          const item = this.records[i];
          item.fechaDebito = this.$moment(item.fechaDebito).format(
            "YYYY-MM-DD"
          ); // Todo: ver qué pasa cuando graba
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
      this.primeraBusquedaRealizada = true;
    },
    validar() {
      // validaciones
      if (this.formatoEnvioId === 0) {
        this.alertWarning("Debe elegir un formato de envío.");
        return false;
      }

      if (this.enviarSms && this.modeloSmsId == 0) {
        this.alertWarning("Debe elegir un modelo de envío de SMS.");
        return false;
      }

      if (this.selectedCuotas.length === 0) {
        this.alertWarning("Debe seleccionar al menos una cuota.");
        return false;
      }

      if (
        this.formatosEnvio.find((f) => f.id == this.formatoEnvioId) != null &&
        this.formatosEnvio.find((f) => f.id == this.formatoEnvioId)
          .requiereFechaRendicion &&
        !this.filtro.fechaRendicion
      ) {
        this.alertWarning(
          "El formato seleccionado requiere el ingreso de la Fecha de Rendición. Por favor, verifique."
        );
        return false;
      }

      if (
        this.formatosEnvio.find((f) => f.id == this.formatoEnvioId) != null &&
        this.formatosEnvio.find((f) => f.id == this.formatoEnvioId)
          .requiereFechaPresentacion &&
        !this.filtro.fechaPresentacion
      ) {
        this.alertWarning(
          "El formato seleccionado requiere el ingreso de la Fecha de Presentación. Por favor, verifique."
        );
        return false;
      }

      return true;
    },
    async generarArchivo() {
      if (!this.validar()) return;

      this.loading = true;
      try {
        await http
          .post(
            "archivosDebito/generararchivo",
            JSON.stringify({
              listaCuotas: this.selectedCuotas,
              empresaId: this.filtro.empresaId,
              formatoEnvioId: this.formatoEnvioId,
              generarLog: this.generarLog,
              fechaRendicion: this.filtro.fechaRendicion,
              fechaPresentacion: this.filtro.fechaPresentacion,
              queGenerar: this.filtro.queGenerar,
              modeloEnvioSmsId: this.modeloSmsId,
              dividirCuotas: this.filtro.dividirCuotas,
              dividirCuotasIguales: this.filtro.dividirCuotasIguales,
              dividirCuotasEn: this.filtro.dividirCuotasEn,
              dividirCuotasMaximo: this.filtro.dividirCuotasMaximo,
              enviarPrimerParte: this.filtro.enviarPrimerParte,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.length == 1)
              this.alertSuccess(
                "Se generó correctamente el archivo de débitos. Se procederá a su descarga."
              );
            else
              this.alertSuccess(
                "Se generaron correctamente " +
                  resp.length +
                  " archivos de débitos. Se procederá a su descarga individual."
              );

            if (resp.length > 0) {
              for (let index = 0; index < resp.length; index++) {
                if (resp[index].completo) {
                  this.downloadFile(resp[index]);

                  if (this.generarLog && resp[index].logId)
                    this.printLog({ id: resp[index].logId });
                }
              }
            }
          })
          .catch((e) => {
            this.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async procesarEnvioApi() {
      if (!this.validar()) return;

      this.loading = true;
      try {
        var api = "";
        if (this.formatoEnvioId == 16) api = "procesarpagoscoin";
        else if (
          this.formatoEnvioId == 1001 &&
          !this.filtro.buscarDeTablaAImpactarNormales
        )
          api = "generarlotecardcredporcliente";
        else if (
          this.formatoEnvioId == 1001 &&
          this.filtro.buscarDeTablaAImpactarNormales
        )
          api = "generarlotecardcredporcliente";

        await http
          .post(
            "archivosDebito/" + api,
            JSON.stringify({
              listaCuotas: this.selectedCuotas,
              listaPorCliente: this.recordsPreProcesoApi,
              empresaId: this.filtro.empresaId,
              formatoEnvioId: this.formatoEnvioId,
              generarLog: this.generarLog,
              fechaRendicion: this.filtro.fechaRendicion,
              fechaPresentacion: this.filtro.fechaPresentacion,
              queGenerar: this.filtro.queGenerar,
              modeloEnvioSmsId: this.modeloSmsId,
              dividirCuotas: this.filtro.dividirCuotas,
              dividirCuotasEn: this.filtro.dividirCuotasEn,
              enviarPrimerParte: this.filtro.enviarPrimerParte,
              horaImpacto: this.filtro.horaImpacto,
              diasBarrido: this.filtro.diasBarrido,
              descuentoExcedeDisponible: this.filtro.descuentoExcedeDisponible,
              descuentoSinFondos: this.filtro.descuentoSinFondos,
            })
          )
          .then((res) => {
            console.log(res);

            if (this.formatoEnvioId == 16) {
              this.recordsProcesoApi = res.list;
              this.showResultadoProceso = true;
            } else if (this.formatoEnvioId == 1001) {
              this.alertSuccess("Se generó el Lote de Barrido Nº" + res.lote);
            }
          })
          .catch((e) => {
            this.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async preProcesarEnvioApiCardCred() {
      if (!this.validar()) return;

      this.loading = true;
      try {
        await http
          .post(
            "archivosDebito/pregenerarlotecardcred",
            JSON.stringify({
              listaCuotas: this.selectedCuotas,
              empresaId: this.filtro.empresaId,
              formatoEnvioId: this.formatoEnvioId,
              generarLog: this.generarLog,
              fechaRendicion: this.filtro.fechaRendicion,
              fechaPresentacion: this.filtro.fechaPresentacion,
              queGenerar: this.filtro.queGenerar,
              modeloEnvioSmsId: this.modeloSmsId,
              dividirCuotas: this.filtro.dividirCuotas,
              dividirCuotasEn: this.filtro.dividirCuotasEn,
              enviarPrimerParte: this.filtro.enviarPrimerParte,
              horaImpacto: this.filtro.horaImpacto,
              descuentoExcedeDisponible: this.filtro.descuentoExcedeDisponible,
              descuentoSinFondos: this.filtro.descuentoSinFondos,
            })
          )
          .then((res) => {
            this.recordsPreProcesoApi = res;
            this.showResultadoPreProceso = true;
          })
          .catch((e) => {
            this.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get("empresas"); // traigo todas
        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/habilitadosparausuario?soloActivos=true&usuarioId=" +
            this.user.id
        );

        this.canalesVenta = result.list;

        this.canalesVenta.unshift({ id: 0, nombre: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get("productos/");

        this.productos = result.list;

        this.productos.unshift({ id: 0, descripcion: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadPlanes() {
      this.loading = true;
      try {
        var result = await http.get(
          "planes?empresaId=" + this.filtro.empresaId
        ); // traigo todos
        this.planes = result.list;

        this.togglePlanes(); //agrego esto para que por defecto estén todos marcados
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormatosEnvio() {
      this.loading = true;
      try {
        var result = await http.get("archivosDebito/formatosenvio"); // traigo todos

        this.formatosEnvio = result.list.filter(
          (f) =>
            f.descripcion.includes("COIN") || f.descripcion.includes("Cardcred")
        );

        //this.formatosEnvio.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormatoEnvio() {
      this.loading = true;
      try {
        var result = await http.get("archivosDebito/formatosenvio"); // traigo todos

        this.formatoEnvio = result.list.filter(
          (f) =>
            f.descripcion.includes("COIN") || f.descripcion.includes("Cardcred")
        );
        this.formatoEnvio.unshift({ id: 0, descripcion: "(Todos)" });
        this.formatoEnvio.push({ id: 1016, descripcion: "API Coin" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstudios() {
      this.loading = true;
      try {
        var result = await http.get("estudiosexternos?limit=999");

        this.estudios = result.list;

        this.estudios.unshift({ id: 0, descripcion: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadPreLotes() {
      this.loading = true;
      try {
        var result = await http.get(
          "archivosdebito/getlistaprelotes?formatoId=" + this.formatoEnvioId
        );

        this.preLotes = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadLogEnvios() {
      this.loadingLog = true;
      try {
        var result = await http.get(
          "archivosDebito/listlogenvios?formatoId=" +
            this.formatoEnvioLogId +
            "&fechaDesde=" +
            this.periodoLote.desde +
            "&fechaHasta=" +
            this.periodoLote.hasta +
            "&limit=" +
            this.optionsLog.itemsPerPage +
            "&page=" +
            this.optionsLog.page +
            "&sortby=" +
            this.optionsLog.sortBy +
            "&descending=" +
            (this.optionsLog.sortDesc.length > 0
              ? this.optionsLog.sortDesc
              : "false")
        );

        this.recordsLog = result.list;
        this.totalItemsLog = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingLog = false;
    },
    async loadLogEnviosDetalle(log) {
      this.loadingLogDetalle = true;
      try {
        var result = await http.get(
          "archivosDebito/listlogenviosdetalle?logId=" +
            log.id +
            "&limit=" +
            this.optionsLogDetalle.itemsPerPage +
            "&page=" +
            this.optionsLogDetalle.page +
            "&sortby=" +
            this.optionsLogDetalle.sortBy +
            "&descending=" +
            (this.optionsLogDetalle.sortDesc.length > 0
              ? this.optionsLogDetalle.sortDesc
              : "false")
        );

        this.recordsLogDetalle = result.list;
        this.totalItemsLogDetalle = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingLogDetalle = false;
    },
    async verResultadosEnvios(item, incluirDebitos, incluirRechazos) {
      this.selectedPersonaId = item.personaId;
      this.showListaCreditos = true;

      var params = {
        width: 800,
        visible: true,
        PersonaId: item.personaId,
        CuentaBancoId: item.cuentaBancoId,
        TipoDeuda: item.tipoDeuda,
        DeudaId: item.deudaId,
        IncluirDebitos: incluirDebitos,
        IncluirRechazos: incluirRechazos,
      };

      this.setActiveTask({
        task: "app-resultados-envio-debito",
        props: params,
      });
    },
    async loadEntidadesFinancieras() {
      this.loading = true;
      try {
        var result = await http.get("entidadesfinancieras"); // traigo todas
        this.bancos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    togglePlanes() {
      this.$nextTick(() => {
        if (this.todosLosPlanesMarcados) {
          this.filtro.planes = [];
        } else {
          this.filtro.planes = this.planes.map(function (p) {
            return p.id;
          });
        }
      });
    },
    async downloadFile(file) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(resp.fileName, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    async traerListaOperacionesDeExcel() {
      if (!this.archivoFiltroOperaciones) return;
      if (!this.archivoFiltroOperaciones.name.includes(".xls")) {
        this.archivoFiltroOperaciones = [];
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;
      let formData = new FormData();

      formData.append("archivo", this.archivoFiltroOperaciones);

      try {
        var listaOps = await http.post(
          "archivosDebito/excelAFiltroOperaciones",
          formData
        );
        console.log(listaOps);
        this.filtro.operacionesFiltro = listaOps;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      /* http.post('archivosDebito/excelAFiltroOperaciones', formData)
        .then(resp => {
            Vue.$log.debug(resp);
        })
        .catch((e) => {
            this.alertError(e)
        }); */

      this.loading = false;
    },
    async cargarListaOperacionesDeExcel() {
      if (!this.archivoProcesoOperaciones) return;
      if (!this.archivoProcesoOperaciones.name.includes(".xls")) {
        this.archivoProcesoOperaciones = [];
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      let filter = this.filtro;

      if (filter.reciclaje && filter.fechaReciclaje == "") {
        this.alertWarning("Por favor, especifique la fecha de reciclaje");
        return;
      }

      if (filter.diferirFechaDebito && filter.diasDiferirFechaDebito <= 0) {
        this.alertWarning(
          "Por favor, especifique la cantidad de días a diferir el débito"
        );
        return;
      } else if (!filter.diferirFechaDebito) {
        filter.diasDiferirFechaDebito = 0;
      }

      this.loading = true;
      let formData = new FormData();

      formData.append("archivo", this.archivoProcesoOperaciones);

      formData.append("empresaId", filter.empresaId);
      formData.append("diaCobroPorFechaReal", filter.diaCobroPorFechaReal);
      formData.append(
        "calcularFechaDebitoAFuturo",
        filter.calcularFechaDebitoAFuturo
      );
      formData.append("reciclaje", filter.reciclaje);
      formData.append("fechaReciclaje", filter.fechaReciclaje);
      formData.append("diferirFechaDebito", filter.diferirFechaDebito);
      formData.append("diasDiferirFechaDebito", filter.diasDiferirFechaDebito);

      try {
        var result = await http.post(
          "archivosDebito/excelAOperacionesParaDebitoTarjeta",
          formData
        );

        this.selectedCuotas = []; // limpio las cuotas seleccionadas

        this.records = result.list;

        console.log(this.records);

        for (let i = 0; i < this.records.length; i++) {
          const item = this.records[i];
          item.fechaDebito = this.$moment(item.fechaDebito).format(
            "YYYY-MM-DD"
          ); // Todo: ver qué pasa cuando graba
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
      this.primeraBusquedaRealizada = true;
    },
    async loadModelosSMS() {
      this.loading = true;
      try {
        var result = await http.get("modelossms");

        this.listModelosSms = result.list.filter((x) => x.tipoGestionId == 4); //modelos para tipo de gestión débitos por CBU
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async printLog(item) {
      let params = [];
      params.push({
        Version: this.$store.state.version, // version
        LoteProcesoId: item.id,
      });

      console.log(params);

      await this.setReporteActivo({
        reporte: "Respaldatorio Envio Debitos.trdp",
        params: params,
      });
      var ret = await window.open("/report-viewer");
      if (ret == null) {
        this.alertError(
          "Atención, no pudo abrise una nueva ventana con el Reporte. Es probable que el navegador esté bloqueando las ventanas emergentes. Verifique"
        );
      }
    },
  },
};
</script>
